import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import anime from "animejs";
import { RootState } from "app/store";
import I18n from "common/i18n";
import Constants from "common/constant";
import { actions } from "features/creator/slice";
import { DisplayMode, ProjectPanelType } from "features/creator/types";
import { TopLayout } from "features/creator/tutorial/top/stages/Layout";

const Step = (props: { back: () => void; next: () => void; close: () => void }) => {
  const { next } = props;
  const dispatch = useDispatch();
  const selectedProjectId = useSelector((state: RootState) => state.creator.selectedProjectId);

  useEffect(() => {
    anime({
      targets: document.getElementsByClassName(`app-project-card-${selectedProjectId}`),
      opacity: [0, 1],
      duration: 800,
      easing: "easeInOutQuad",
    });
    dispatch(actions.updateSelectedProjectId(null));
    dispatch(actions.updateDisplayMode(DisplayMode.NONE));
    dispatch(actions.updateProjectPanel(ProjectPanelType.SHARED));
    dispatch(actions.updateSortFilterPanel(true));
    dispatch(actions.updateKeyword(""));
    dispatch(
      actions.handleUpdatePublishedProjectFilter({
        type: "onlyOfficial",
        value: true,
      }),
    );
    dispatch(
      actions.handleUpdatePublishedProjectFilter({
        type: "userFavorited",
        value: false,
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <TopLayout next={next}>
      <div className="flex-col-el flex-center gap-6 ml-11 mt-10">
        <p className="text-body text-[80px] text-white leading-[70px]">5</p>

        <div className="flex-col-center gap-1">
          <div className="flex-col-center">
            <img
              alt="app card"
              src={`${Constants.assetHost}/assets/images/app_card_user.png`}
              className="w-[30px] h-[36px]"
            />

            <div className="flex-col-el flex-center absolute top-[8px] w-full px-[2px] h-[24px]">
              <div className="w-full h-full bg-white" />
            </div>
          </div>

          <div className="flex-row-el flex-center gap-1">
            <p className="text-body text-[20px] text-white text-center whitespace-pre">
              {I18n.locale === "ja" ? "アプリの\nつくりかた" : "アプリの\n作り方"}
            </p>
          </div>
        </div>
      </div>
    </TopLayout>
  );
};

export default Step;
